import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";
export default class PaymentsService extends ApiService {
  namespace = "payments";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "SafetyBox";
  DOMAIN = DOMAIN.PAYMENTS;
  data = [];
  favicon = "database";
  name = "payments";
  showLeftBar = false;
  singular = this.terminology.deposit.singular;
  plural = this.terminology.deposit.plural;
  vowel = this.terminology.deposit.vowel;
  layout = 2;
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Deposits",
      icon: AppIcons.BULLETS,
      services: DOMAIN.PAYMENTS,
    },
    {
      key: "create",
      label: "Record a Deposit",
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: "Methods",
      icon: AppIcons.BOX_WITH_STAR,
      field: "method",
    },
    {
      header: "Number",
      icon: AppIcons.SHRED,
      field: "number",
    },
    {
      header: "Items Deposited",
      icon: AppIcons.NUMBER,
      field: "deposited",
    },
    {
      header: "Item Deposited",
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.date).format("MM/DD/YYYY").format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit this Deposit...",
      icon: AppIcons.EDIT,
      services: DOMAIN.DEPOSIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
    {
      key: "view",
      label: "View Journal",
      services: DOMAIN.CHECK_LAYOUT,
      icon: AppIcons.EYE,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Record a Deposit",
      icon: AppIcons.LIST,
      services: DOMAIN.DEPOSIT,
    },
  ];

  constructor() {
    super("payments");
  }
}
